import React from 'react';

function Layout({ children }) {

  return (
    <div className="h-full min-h-0 w-full bg-gray-100 dark:bg-gray-900">
      <main className="h-full min-h-0 w-full">
        {children}
      </main>
    </div>
  );
}

export default Layout;